























import { User } from '@/api/Auth/auth.interface'
import ActionButton from '@/components/ActionButton.vue'
import UserTreeviewDialog from '@/components/Agency/Users/UserTreeviewDialog.vue'

import Vue, { PropType } from 'vue'
import TextButton from '~/components/TextButton.vue'
export default Vue.extend({
  components: {
    appUserTreeviewDialog: UserTreeviewDialog,
    appActionButton: ActionButton,
    TextButton,
  },
  props: {
    item: Object as PropType<User>,
    text: Boolean,
  },
  data() {
    return {
      dialog: false,
    }
  },
})
